import { get, post, put, remove } from '../services/common/common.service';
import {
  entitelmentHistory,
  entitlementProductHistoryEndPoints,
  entitlementsNotesEndPoints,
} from '../constants/endpoint';

export const updateEntitlementHistoryActiveInactive = (payload) =>
  put(entitelmentHistory.updateActiveInactive, payload);

export const getEntitlementStatus = (payload) => {
  get(
    `${entitelmentHistory.getStatusOFEntitlement}?entitlementId=${payload.entitlementId}`,
    payload
  );
};

export const getSpecificEntitlementData = (payload) =>
  get(
    `${entitelmentHistory.getEntitlementData}?entitlementId=${payload.entitlementId}`,
    payload
  );

export const getEntitlementHistoryData = (payload) =>
  get(
    `${entitelmentHistory.getEntitlementHistory}?entitlementId=${payload.entitlementId}&siteStartDate=${payload.siteStartDate}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );

export const getEntHisDataForValidation = (payload) =>
  get(
    `${entitelmentHistory.getEntitlementHistory}?entitlementId=${payload.entitlementId}&siteStartDate=${payload.siteStartDate}&recordCount=-1&pageIndex=${payload.pageIndex}`,
    payload
  );

export const createEntitlementHistoryNote = (payload) =>
  post(entitelmentHistory.insertEntitlementNote, payload);

export const getEntitlementHistoryStatus = (payload) =>
  get(entitelmentHistory.getEntitlementHistoryStatus, payload);

export const getEntitlementServiceLevel = (payload) =>
  get(entitelmentHistory.getEntitlementServiceLevel, payload);

export const getEntitlementHistoryDetails = (payload) =>
  get(
    `${entitelmentHistory.getEntitlementHistoryDetails}?entitlementId=${payload.entitlementId}&siteStartDate=${payload.siteStartDate}&effectiveDate=${payload.effectiveDate}`,
    payload
  );

export const createEntitlementHistory = (payload) =>
  post(entitelmentHistory.insertEntitlementHistory, payload);

export const fetchEntitlementNotes = (payload) => {
  return get(
    `${entitlementsNotesEndPoints.getEntitlementNotesData}?entitlementId=${payload.entitlementId}&recordCount=${payload.RecordCount}&pageIndex=${payload.PageIndex}`,
    payload
  );
};

export const createEntitlementNote = (payload) =>
  post(entitlementsNotesEndPoints.createEntitlementNote, payload);

export const getEntitlementProductHistory = (payload) =>
  get(
    `${entitlementProductHistoryEndPoints.getEntitlementProductHistory}?entitlementId=${payload.entitlementId}`,
    payload
  );

export const transferEntitlement = (payload) =>
  get(
    `${entitelmentHistory.entitlementTransfer}?siteId=${payload.siteId}&activityDate=${payload.activityDate}`,
    payload
  );

export const entitlementTransferData = (payload) =>
  post(
    entitelmentHistory.getEntitlementTransferData,
    payload
  );

export const entitlementWarrantyHistory = (payload) =>
  get(
    `${entitelmentHistory.entitlementWarrantyHistory}?entitlementId=${payload.entitlementId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );

export const entitlementSerialNumberHistory = (payload) =>
  get(
    `${entitelmentHistory.entitlementSerialNumberHistory}?warrantyId=${payload.warrantyId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );

export const getEntitlementSpecificWarrantyHistoryDetails = (payload) =>
  get(
    `${entitelmentHistory.getEntitlementSpecificWarrantyHistoryDetails}?entitlementId=${payload.entitlementId}&warrantyStartDate=${payload.warrantyStartDate}`,
    payload
  );

export const checkWarrantyHistoryUpsert = (payload) =>
  get(
    `${entitelmentHistory.checkWarrantyHistoryUpsert}?entitlementId=${payload.enitlementId}`,
    payload
  );

export const validateWarrantyHistoryStartDate = (payload) =>
  get(
    `${entitelmentHistory.validateWarrantyHistoryStartDate}?entitlementId=${payload.entitlementId}&warrantyStartDate=${payload.warrantyStartDate}`,
    payload
  );

export const createNewEntitlementWarranty = (payload) =>
  post(entitelmentHistory.createNewEntitlementWarranty, payload);

export const updateNewEntitlementWarranty = (payload) =>
  put(entitelmentHistory.createNewEntitlementWarranty, payload);

export const deleteNewEntitlementWarranty = (payload) =>
  remove(entitelmentHistory.createNewEntitlementWarranty, payload);

export const createUpdateNewEntitlementHistory = (payload) =>
  post(entitelmentHistory.createUpdateNewEntitlementHistory, payload);

export const saveAndCloseEntitlementTransfer = (payload) =>
  post(entitelmentHistory.saveAndCloseEntitlementTransfer, payload);

export const saveAndCloseEntitlementSite = (payload) =>
  post(entitelmentHistory.saveAndCloseEntitlementSite, payload);

export const saveAndCloseEntitlementSiteActivity = (payload) =>
  post(entitelmentHistory.saveAndCloseEntitlementSiteActivity, payload);
